import {and, collection, doc, getDocs, getFirestore, or, query, setDoc, where} from "firebase/firestore";
import {app} from "../libs/Firebase";
import {Suspense, useContext} from "react";
import {Register} from "../Register";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

let executingPromise;
let executingUsersPromise;
const db = getFirestore(app);
const authUserCollectionRef = collection(db, 'users');
const email = localStorage.getItem('email');
const docRef = query(collection(db,"tournaments"));
const querySnapshot = await getDocs(docRef);


function getTournaments() {
    const repeat = [];
    querySnapshot.forEach((doc) => {
        const data = doc.data();
        const key = doc._key.path.get(doc._key.path.length - 1);
        repeat.push(
            <Card style={{width: '18rem', margin: "10px"}}>
                <Card.Body>
                    <Card.Title>{data["name"]}</Card.Title>
                    <Card.Text>
                        {data["short"]}
                    </Card.Text>
                    <Button variant="primary" onClick={()=>tournament(data["id"],data["name"],key)}>詳細を見る</Button>
                </Card.Body>
            </Card>
        )
    })
    return (
        <div className="container" style={{display: "flex", flexWrap: "wrap", justifyContent: "space-around"}}>
            {repeat}
            <Card style={{width: '18rem', margin: "10px"}}>
                <Card.Body>
                    <Card.Title>新規作成</Card.Title>
                    <Card.Text>
                        新しい大会を作成する
                    </Card.Text>
                    <Button variant="primary" onClick={()=>createTournament()}>作成</Button>
                </Card.Body>
            </Card>
        </div>
    )
}
function createTournament(){
    window.location.href = '/admin/tournament/create'
}
function tournament(id,name,key){
    sessionStorage.setItem('adminTID',id)
    sessionStorage.setItem('tname',name)
    sessionStorage.setItem('key',key)
    window.location.href = '/admin/tournament'
}
const getNotVerifiedUsers = async () => {
    const q = query(authUserCollectionRef,where('isVerified' ,'==',false),where('isDeny','==', false));
    let all = [];
    try {
        const querySnapshot = await getDocs(q);
        querySnapshot.docs.map((doc)=>{
            const data = doc.data();
            const d = {
                email: data.email,
                displayName: data.displayName,
                discordId: data.discordId,
                gameId: data.gameId,
                isVerified: data.isVerified,
                isDeny: data.isDeny,
                gameName: data.gameName,
            };
            all.push(d)
            return d;
        })
        return all;
    }catch (error){
        return Promise.reject(error);
    }
}

const getAuthUserInfo = async () => {
    const q = query(authUserCollectionRef, where('email', '==', email));
    try {
        const querySnapshot = await getDocs(q);//検索済みのデータ取得
        // 一致するものをmapで処理しdataオブジェクトをコールバック
        return querySnapshot.docs.map((doc) => {
            const data = doc.data();
            return {
                displayName: data.displayName,
                email: data.email,
                discordId: data.discordId,
                gameId: data.gameId,
                isVerified: data.isVerified,
                isAdmin: data.isAdmin,
            };
        });
    }catch (error){
        return Promise.reject(error);
    }
};
class PromiseWrapper{
    #state;
    constructor(promise:Promise) {
        const p = promise.then((result) => {
            this.#state = {
                type: "fulfilled",
                result: result
            };
            return result;
        }).catch((e)=>{
            this.#state = {
                type: "rejected",
                error: e
            };
            throw e;
        });
        this.#state ={
            type:"pending",
            promise: p
        };
    }
    get(){
        switch (this.#state.type) {
            case "pending": {
                throw this.#state.promise;
            }
            case "fulfilled": {
                return this.#state.result;
            }
            case "rejected": {
                throw this.#state.error;
            }
        }
    }
}
function fetchData(email) {
    if (!executingPromise) {
        executingPromise = new PromiseWrapper(getAuthUserInfo(email));
    }
    return executingPromise.get();
}
function fetchUsers(){
    if (!executingUsersPromise){
        executingUsersPromise = new PromiseWrapper(getNotVerifiedUsers());
    }
    return executingUsersPromise.get();
}
function SuspendedComponent() {
    const r = useContext(Register);
    const loginUser = r.loginUser;
    const login = r.login;
    const logout = r.logout;
    const data = fetchData(email);
    const users = fetchUsers();
    let displayName;
    let discordId;
    let gameId;
    let isAdmin;
    let gameName;
    data.map((da) => {
        displayName = da.displayName;
        discordId = da.discordId;
        gameId = da.gameId;
        isAdmin = da.isAdmin;
        gameName = da.gameName;
        if (!displayName){
            displayName = "ユーザー名未入力"
        }
        return da.displayName;
    })
    const Users = () => {
        const allUser = users.map((user,index) => {
            return(
                <>
                <Card style={{width: '18rem', margin: "10px"}} id={index}>
                    <Card.Body>
                        <Card.Title>{user.displayName}</Card.Title>
                        <Card.Text>
                            discord:{user.discordId}<br></br>
                            ポケポケID:{user.gameId}<br/>
                            ポケポケユーザー名:{user.gameName}<br/>
                            <span id={"duplicate"} hidden={true}>重複があるので却下してください</span>
                        </Card.Text>
                        <Button variant="primary" style={{marginRight:'60px'}} onClick={()=>{action(user.email,user.displayName,user.discordId,user.gameId,index,true)}}>承認する</Button>
                        <Button variant="primary" style={{background:'#c85b5b',borderColor:'#c85b5b'}} onClick={()=>{action(user.email,user.displayName,user.discordId,user.gameId,index,false)}}>却下する</Button>
                    </Card.Body>
                </Card>
                </>
            );
        })
        return <>{allUser}</>;
    }
    const navbar = () => {
        return (
            <div className="align">
                <nav className="navigation navigation--inline">
                    <ul>
                        <li>
                            <a onClick={() => link('home')}>
                                <svg className="icon icon--2x">
                                    <use xlinkHref="#icon-home"/>
                                </svg>
                                <span className="invisible">Home</span>
                            </a>
                        </li>
                        <li>
                            <a onClick={() => link('tournaments')}>
                                <svg className="icon icon--2x">
                                    <use xlinkHref="#icon-search"/>
                                </svg>
                                <span className="invisible">Search</span>
                            </a>
                        </li>
                        <li>
                            <a onClick={() => link('session')}>
                                <svg className="icon icon--2x">
                                    <use xlinkHref="#icon-trophy"/>
                                </svg>
                                <span className="invisible">Products</span>
                            </a>
                        </li>
                        <li>
                            <a onClick={() => link('notices')}>
                                <svg className="icon icon--2x">
                                    <use xlinkHref="#icon-bell"/>
                                </svg>
                                <span className="invisible">Notifications</span>
                            </a>
                        </li>
                        <li>
                            <a onClick={() => link('mypage')}>
                                <svg className="icon icon--2x">
                                    <use xlinkHref="#icon-user"/>
                                </svg>
                                <span className="invisible">Profile</span>
                            </a>
                        </li>
                    </ul>
                </nav>

                <svg xmlns="http://www.w3.org/2000/svg" className="icons">
                    <symbol id="icon-bell" viewBox="0 0 92 92">
                        <path
                            d="M84 71.5c-6.7 0-9.3-3.9-9.3-28.4 0-19.2-8.7-31.2-23.7-33v-6.2c0-2.2-1.8-4-4-4s-4 1.8-4 4v6c-16 1.3-25.3 13.5-25.3 33.1 0 24.5-2.9 28.4-9.7 28.4-2.1.1-4 1.6-4 3.8 0 2.3 1.8 3.8 4 3.8h26c.3 3 1.2 6.7 3.6 9.3 2.1 2.3 4.9 3.6 8.2 3.6 3.3 0 6.1-1.4 8.2-3.6 2.5-2.7 3.5-6.3 3.9-9.3h26.1c2.2 0 4-1.5 4-3.8 0-2.2-1.8-3.7-4-3.7zm-35.8 11.4c-.4.4-1 1-2.4 1-1.3 0-1.9-.6-2.3-1-.7-.9-1.2-1.9-1.4-3.9h7.8999999999999995c-.4 2-.9 3-1.8 3.9zm-1.6-11.9h-24.8c3.7-7 3.7-17.9 3.7-28.1 0-16.3 7.1-24.9 19.9-24.9h1.1c12.8 0 19.9 8.6 19.9 24.9 0 10.2 0 21.1 3.7 28.1h-23.5zm14.2-35.5c.1 1.9-1.4 3.6-3.3 3.7h-.2c-1.8 0-3.4-1.4-3.5-3.3-.3-4.5-3.8-6.1-4.2-6.3-1.8-.8-2.6-2.8-1.9-4.6.7-1.8 2.7-2.6 4.5-1.9.4.2 8.1 3.4 8.6 12.4z"/>
                    </symbol>
                    <symbol id="icon-cart" viewBox="0 0 92 92">
                        <path
                            d="M91.8 27.3l-10.7 33.7c-.8 2.4-2.9 4-5.4 4h-41.3c-2.4 0-4.7-1.5-5.5-3.7l-15.8-42.3h-9.1c-2.2 0-4-1.8-4-4s1.8-4 4-4h11.9c1.7 0 3.2 1.1 3.8 2.7l16.3 43.3h38l8.5-27h-47.1c-2.2 0-4-1.8-4-4s1.8-4 4-4h52.6c1.3 0 2.5.7 3.2 1.7.8 1 1 2.4.6 3.6zm-55.4 43c-1.7 0-3.4.7-4.6 1.9-1.2 1.2-1.9 2.9-1.9 4.6 0 1.7.7 3.4 1.9 4.6 1.2 1.2 2.9 1.9 4.6 1.9s3.4-.7 4.6-1.9c1.2-1.2 1.9-2.9 1.9-4.6 0-1.7-.7-3.4-1.9-4.6-1.2-1.2-2.9-1.9-4.6-1.9zm35.9 0c-1.7 0-3.4.7-4.6 1.9s-1.9 2.9-1.9 4.6c0 1.7.7 3.4 1.9 4.6 1.2 1.2 2.9 1.9 4.6 1.9 1.7 0 3.4-.7 4.6-1.9 1.2-1.2 1.9-2.9 1.9-4.6 0-1.7-.7-3.4-1.9-4.6s-2.9-1.9-4.6-1.9z"/>
                    </symbol>
                    <symbol id="icon-home" viewBox="0 0 92 92">
                        <path
                            d="M88 49c-1 0-2-.4-2.8-1.1l-39.2-38.3-39.2 38.3c-1.6 1.5-4.1 1.5-5.7-.1-1.5-1.6-1.5-4.1.1-5.7l42-41c1.6-1.5 4-1.5 5.6 0l42 41c1.6 1.5 1.6 4.1.1 5.7-.8.8-1.9 1.2-2.9 1.2zm-8.8 39v-39.1c0-2.2-1.8-4-4-4s-4 1.8-4 4v35.1h-12.5v-21.4c0-2.9-2.4-5.3-5.3-5.3h-14.8c-2.9 0-5.3 2.4-5.3 5.3v21.4h-12.5v-35.1c0-2.2-1.8-4-4-4s-4 1.8-4 4v39.1c0 2.2 1.8 4 4 4h20.5c2.2 0 4-1.8 4-4v-22.7h9.5v22.7c0 2.2 1.8 4 4 4h20.5c2.2 0 3.9-1.8 3.9-4z"/>
                    </symbol>
                    <symbol id="icon-search" viewBox="0 0 92 92">
                        <path
                            d="M57.8 2.2c-17.1 0-31 14.1-31 31.3 0 7.3 2.5 13.9 6.6 19.3l-29.4 29.8c-1.7 1.8-1.7 4.6 0 6.3.9.9 2 1.3 3.1 1.3 1.2 0 2.3-.4 3.2-1.3l29.4-29.8c5.1 3.7 11.3 5.8 18 5.8 17.1 0 31-14.1 31-31.3s-13.8-31.4-30.9-31.4zm0 54.8c-12.7 0-23-10.5-23-23.4 0-12.9 10.3-23.4 23-23.4s23 10.5 23 23.4c0 12.9-10.3 23.4-23 23.4zm15.5-23c-.2 1.7-1.7 3-3.4 3h-.5c-1.9-.3-3.2-2-3-3.9.7-5.2-5.1-7.9-5.4-8-1.7-.8-2.5-2.9-1.7-4.6s2.8-2.5 4.6-1.8c.4.1 10.8 4.9 9.4 15.3zm-7.3 7.6c.7.7 1.2 1.8 1.2 2.8 0 1.1-.4 2.1-1.2 2.8-.7.7-1.8 1.2-2.8 1.2-1 0-2.1-.4-2.8-1.2-.7-.7-1.2-1.8-1.2-2.8 0-1 .4-2.1 1.2-2.8.7-.7 1.8-1.2 2.8-1.2 1 0 2 .4 2.8 1.2z"/>
                    </symbol>
                    <symbol id="icon-user" viewBox="0 0 92 92">
                        <path
                            d="M46 57.1c14.8 0 26.9-12.1 26.9-27 0-15-12.1-27.1-26.9-27.1s-26.9 12.1-26.9 27c0 15 12.1 27.1 26.9 27.1zm0-46.1c10.4 0 18.9 8.5 18.9 19s-8.5 19-18.9 19-18.9-8.5-18.9-19 8.5-19 18.9-19zm12.5 48.7c-1.3-.4-2.8-.1-3.8.8l-8.7 7.4-8.7-7.4c-1.1-.9-2.5-1.2-3.8-.8-5.6 1.8-33.5 11.4-33.5 25.3 0 2.2 1.8 4 4 4h84c2.2 0 4-1.8 4-4 0-13.9-27.9-23.5-33.5-25.3zm-48.4 21.3c4.4-4.7 15-9.9 23.8-12.9l9.5 8.1c1.5 1.3 3.7 1.3 5.2 0l9.5-8.1c8.8 3.1 19.4 8.3 23.8 12.9h-71.8z"/>
                    </symbol>
                    <symbol id="icon-trophy" viewBox="0 0 16 16">
                        <path
                            d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5q0 .807-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33 33 0 0 1 2.5.5m.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935m10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935M3.504 1q.01.775.056 1.469c.13 2.028.457 3.546.87 4.667C5.294 9.48 6.484 10 7 10a.5.5 0 0 1 .5.5v2.61a1 1 0 0 1-.757.97l-1.426.356a.5.5 0 0 0-.179.085L4.5 15h7l-.638-.479a.5.5 0 0 0-.18-.085l-1.425-.356a1 1 0 0 1-.757-.97V10.5A.5.5 0 0 1 9 10c.516 0 1.706-.52 2.57-2.864.413-1.12.74-2.64.87-4.667q.045-.694.056-1.469z"/>
                    </symbol>
                </svg>
            </div>
        )
    }
    if(isAdmin === true){
        return (
            <>
                <div id="home" hidden={true}>

                </div>
                <div id="tournaments" hidden={true}>
                    <h1 className="text-center">承認待ちのユーザー</h1>
                    <Users/>
                </div>
                <div id="session" hidden={true}>
                    {getTournaments()}
                </div>
                <div id="mypage">
                    <div className="user_info">
                        {/*<UserCircleIcon className="user_icon" />*/}
                        <p className="user_name">
                            {loginUser ? loginUser.displayName : 'ゲスト'}
                        </p>
                        <button className="login_btn" onClick={loginUser ? logout : login}>
                            {loginUser ? 'logout' : 'login'}
                        </button>
                    </div>
                    <div className="content">
                        <h1 className="heading-lv1 text-center">Profile</h1>
                        <figure className="profile-image">
                            <img src={loginUser ? loginUser.photoURL : '.'} alt="" width="200"
                                 height="200"/>
                        </figure>
                        <h2 className="heading-lv2 heading-margin text-center">{loginUser ? displayName : 'ゲスト'}</h2>
                        <p className="text text-center">ポケポケID:{gameId}</p>
                        <p className="text text-center">ポケポケユーザー名:{gameName}</p>
                        <p className="text text-center">discord:{discordId}</p>
                        <p className="text text-center" onClick={openHome}>一般メニューに戻る</p>
                    </div>
                </div>
                {navbar()}
            </>
        );
    }else{
        return (
            <>
                <h1>ここにアクセスする権限がありません</h1>
            </>
        )
    }
}

function action(e,n,d,g,i,a) {
    const cityRef = doc(db, 'users',e);
    const userRef = query(authUserCollectionRef,and(where('email','==', e),or(where('isVerified', '==', true),where('isDeny', '==', true))))
    getDocs(userRef).then((result)=>{
        if (result.docs.length !== 0){
            window.alert("既に承認/却下されています")
            document.getElementById(i.toString()).hidden = true;
        }else{
            if (a){
                getDocs(query(authUserCollectionRef,where('displayName', '==',n),where('isVerified','==', true))).then((result)=>{
                    if (result.docs.length !== 0){
                        window.alert("既に使われているユーザー名です。")
                    }else{
                        document.getElementById("duplicate").hidden = true
                        getDocs(query(authUserCollectionRef,where('discordId', '==',d),where('isVerified','==', true))).then((result)=>{
                            if (result.docs.length !== 0){
                                window.alert("既に使われているdiscord IDです。")
                            }else {
                                document.getElementById("duplicate").hidden = true
                                getDocs(query(authUserCollectionRef,where('gameId', '==',g),where('isVerified','==', true))).then((result)=>{
                                    if (result.docs.length !== 0){
                                        window.alert("既に使われているgame IDです。")
                                    }else{
                                        document.getElementById(i.toString()).hidden = true;
                                        document.getElementById("duplicate").hidden = true
                                        setDoc(cityRef, { email: e,displayName:n,discordId:d,gameId:g, isVerified:true}, { merge: true }).then(()=>window.alert("承認しました"));
                                    }
                                })
                            }
                        })
                    }
                })
            }else{
                document.getElementById(i.toString()).hidden = true;
                setDoc(cityRef, { email: e,displayName:null,discordId:null,gameId:null, isVerified:false, isDeny:true}, { merge: true }).then(() =>window.alert("却下しました"));
            }
        }
    })
}
function openHome(){
    window.location.href = "/"
}
function link(link){
    const home = window.document.getElementById('home');
    const tournaments = window.document.getElementById("tournaments");
    const mypage = window.document.getElementById("mypage");
    const session = window.document.getElementById("session");
    if (link === "mypage"){
        if (home){
            home.hidden = true;
        }
        if (tournaments){
            tournaments.hidden = true;
        }
        if (session){
            session.hidden = true;
        }
        if (mypage){
            mypage.hidden = false;
        }
    }
    if (link === "tournaments") {
        if (home) {
            home.hidden = true;
        }
        if (mypage) {
            mypage.hidden = true;
        }
        if (session){
            session.hidden = true;
        }
        if (tournaments) {
            tournaments.hidden = false;
        }
    }
    if (link === "home"){
        if (mypage) {
            mypage.hidden = true;
        }
        if (tournaments) {
            tournaments.hidden = true;
        }
        if (session){
            session.hidden = true;
        }
        if (home) {
            home.hidden = false;
        }
    }
    if (link === "session"){
        if (mypage) {
            mypage.hidden = true;
        }
        if (tournaments) {
            tournaments.hidden = true;
        }
        if (home) {
            home.hidden = true;
        }
        if (session) {
            session.hidden = false;
        }
    }
}

const Admin = () => {
    return (
        <>
            <Suspense fallback={"loading..."}>
                <SuspendedComponent/>
            </Suspense>
        </>
    );
};
export default Admin;